module.exports = __webpack_public_path__ + "img/shop-checked.7abdd15f.svg";